import React, { useEffect, useState } from 'react'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'

import MarketIcon from './../../../assets/img/features/market.svg'
import PharmacyIcon from './../../../assets/img/features/pharmacy.svg'
import HomeIcon from './../../../assets/img/features/home.svg'
import DeliveryIcon from './../../../assets/img/features/delivery.svg'
import CloudComputingIcon from './../../../assets/img/features/cloud-computing.svg'
import CloudStorageIcon from './../../../assets/img/features/cloud-storage.svg'
import AlertIcon from './../../../assets/img/features/alert.svg'
import TemperatureIcon from './../../../assets/img/features/temperature.svg'
import BluetoothIcon from './../../../assets/img/features/bluetooth.svg'
import ReportIcon from './../../../assets/img/features/report.svg'
import ChartIcon from './../../../assets/img/features/chart.svg'
import MapIcon from './../../../assets/img/features/location.svg'



import './index.css'

export default function Services() {
    const [services, setServices] = useState([])

    useEffect(() => {
        setServices([
            { id: 1,  name: 'Monitoramento de supermercado', icon: MarketIcon },
            { id: 2,  name: 'Monitoramento de farmacias', icon: PharmacyIcon },
            { id: 3,  name: 'Monitoramento de casas', icon: HomeIcon },
            { id: 4,  name: 'Monitoramento de cargas', icon: DeliveryIcon },
            { id: 5,  name: 'Tempo real', icon: CloudComputingIcon },
            { id: 6,  name: 'Armazenamento na nuvem', icon: CloudStorageIcon },
            { id: 7,  name: 'Alertas', icon: AlertIcon },
            { id: 8,  name: 'Sensores IOT', icon: TemperatureIcon },
            { id: 9,  name: 'Bluetooth Low Energy', icon: BluetoothIcon },
            { id: 10, name: 'Relatórios', icon: ReportIcon },
            { id: 10, name: 'Gráficos', icon: ChartIcon },
            { id: 11, name: 'Mapa', icon: MapIcon },
        ])
    }, [])

    return (
        <section className="Services grey-background" id="features">
            <Container>
                <h1 className="section-title centered">Features</h1>
                <Row>
                    {services.map((service) => makeCard(service))}
                </Row>
            </Container>
        </section>
    )

    function makeCard(service) {
        return (
            <Col md={4}>
                <Card>
                    <div className="container-image">
                        <Card.Img variant="top" src={service.icon} />
                    </div>
                    <Card.Body>
                        <Card.Title>{service.name}</Card.Title>
                        <Card.Text>
                            Some quick example text to build on the card title and make up the bulk of
                            the card's content.
                                </Card.Text>
                        <Button variant="primary">Saiba mais</Button>
                    </Card.Body>
                </Card>
            </Col>
        )
    }
}